import { CommunityChannelApi } from '@ps/api/community-channel';
import { withClientAPI } from '@ps/functions/utils/api';

import type { MessageReaction } from '../../types/MessageReaction';

/**
 * Toggle a reaction on a message — the server inspects whether the
 * current user has already reacted with this emojiCode and either
 * adds or removes the row. Locally we mirror the toggle optimistically
 * via the `useMyMessageReactions` Firestore subscription, which
 * reflects the change as soon as the server confirms.
 */
export async function toggleMessageReaction({
  creatorId,
  channelId,
  messageId,
  reaction,
}: {
  creatorId: string;
  channelId: string;
  messageId: string;
  reaction: MessageReaction;
}): Promise<void> {
  const api = withClientAPI(CommunityChannelApi);
  await api.communityChannelApiControllerToggleCommunityChannelMessageReaction({
    sellerId: creatorId,
    channelId,
    messageId,
    ToggleCommunityChannelMessageReactionRequest: {
      emoji: reaction.emoji,
      emojiCode: reaction.emojiCode,
      name: reaction.name,
    },
  });
}
